import {
	API_GET_ALL_TUBE_REASON_UNTAKEN,
	API_GET_ALL_TUBE_REASON_ADDED,
	API_ADMIN_GET_ALL_TUBE_REASON,
	API_ADMIN_GET_TUBE_REASON,
	ADMIN_INIT_NEW_TUBE_REASON,
	ADMIN_RESET_FOCUS_TUBE_REASON,
	API_ADMIN_POST_TUBE_REASON,
	API_ADMIN_PATCH_TUBE_REASON,
	API_ADMIN_DELETE_TUBE_REASON,
	API_ADMIN_GET_TUBE_REASON_GROUPS,
	API_GET_ALL_TUBE_REASON_NATURE,
} from 'actions/tubeReason';

export function getAllTubeUntakenReasons() {
	return {
		type: API_GET_ALL_TUBE_REASON_UNTAKEN,
		payload: {
			request: {
				url: `/tubeReasons/untaken`,
			},
		},
	};
}

export function getAllTubeAddedReasons() {
	return {
		type: API_GET_ALL_TUBE_REASON_ADDED,
		payload: {
			request: {
				url: `/tubeReasons/added`,
			},
		},
	};
}


export function getAllTubeNatureReasons() {
	return {
		type: API_GET_ALL_TUBE_REASON_NATURE,
		payload: {
			request: {
				url: `/tubeReasons/nature`,
			},
		},
	};
}

export function adminGetAllTubeReasons() {
	return {
		type: API_ADMIN_GET_ALL_TUBE_REASON,
		payload: {
			request: {
				url: `/admin/tubeReasons`,
			},
		},
	};
}

export function adminGetTubeReason(tubeReason) {
	return {
		type: API_ADMIN_GET_TUBE_REASON,
		payload: {
			request: {
				url: `/admin/tubeReasons/${tubeReason.id}`,
			},
		},
	};
}

export function adminPostTubeReason(tubeReason) {
	return {
		type: API_ADMIN_POST_TUBE_REASON,
		payload: {
			request: {
				url: `/admin/tubeReasons`,
				method: 'POST',
				data: tubeReason,
			},
		},
	};
}

export function adminPatchTubeReason(tubeReason) {
	return {
		type: API_ADMIN_PATCH_TUBE_REASON,
		payload: {
			request: {
				url: `/admin/tubeReasons/${tubeReason.id}`,
				method: 'PATCH',
				data: tubeReason,
			},
		},
	};
}

export function adminDeleteTubeReason(tubeReason) {
	return {
		type: API_ADMIN_DELETE_TUBE_REASON,
		payload: {
			request: {
				url: `/admin/tubeReasons/${tubeReason.id}`,
				method: 'DELETE',
			},
		},
	};
}

export function adminGetTubeReasonGroups() {
	return {
		type: API_ADMIN_GET_TUBE_REASON_GROUPS,
		payload: {
			request: {
				url: `/admin/tubeReasons/groups`,
			},
		},
	};
}

export function initNewTubeReason() {
	return {
		type: ADMIN_INIT_NEW_TUBE_REASON,
	};
}

export function resetFocusTubeReason() {
	return {
		type: ADMIN_RESET_FOCUS_TUBE_REASON,
	};
}
